import { memo } from "react";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { classNames, useTranslate } from "helpers";
import { CALENDAR_TABS } from "./consts";

const TabMenu: React.FC = () => {
  const { t } = useTranslate();

  return (
    <div className="flex border-b border-slate-200 bg-white overflow-x-auto scrollbar-hide">
      {CALENDAR_TABS.map((tab) => (
        <NavLink key={tab.route} end to={tab.route} className="shrink-0">
          {({ isActive }) => (
            <div
              className={classNames(
                "group flex items-center gap-2 font-semibold pl-2 pr-4 py-2 ml-2 first:ml-3 hover:text-sky-600 whitespace-nowrap",
                isActive ? "text-sky-600 border-b-2 border-b-sky-600" : "text-gray-600"
              )}
            >
              <ReactSVG
                src={tab.icon}
                className={classNames(
                  "w-5 h-5 group-hover:stroke-sky-600",
                  isActive ? "stroke-sky-600" : "stroke-slate-500"
                )}
              />
              {t(tab.label)}
            </div>
          )}
        </NavLink>
      ))}
    </div>
  );
};

export default memo(TabMenu);
